import { render, staticRenderFns } from "./Add.modal.vue?vue&type=template&id=70c8ef16"
import script from "./Add.modal.vue?vue&type=script&lang=js"
export * from "./Add.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports